<template>
    <div>
        <div class="crumbs">
            <Breadcrumb v-bind:menuList="menuList"></Breadcrumb>
        </div>
        <div class="container">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="手机号:">
                    <el-input class="s-input" v-model="queryParams.phone" placeholder="请输入手机号" clearable></el-input>
                </el-form-item>
                <!-- <el-form-item label="是否包邮:">
                    <el-select v-model="queryParams.shipping" placeholder="请选择是否包邮" clearable @change="changeQuery">
                        <el-option label="否" :value="1"></el-option>
                        <el-option label="是" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否可以开通店铺:">
                    <el-select v-model="queryParams.shop" placeholder="请选择是否可以开通店铺" clearable @change="changeQuery">
                        <el-option label="否" :value="1"></el-option>
                        <el-option label="是" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态:">
                    <el-select v-model="queryParams.state" placeholder="请选择状态" clearable @change="changeQuery">
                        <el-option label="下线" :value="1"></el-option>
                        <el-option label="上线" :value="2"></el-option>
                    </el-select>
                </el-form-item> -->

                <div style="float: right">
                    <el-button type="primary" @click="changeQuery()">搜索</el-button>
                </div>
            </el-form>
            <div class="action">
                <el-button type="primary" @click="add()">新增</el-button>
                <el-button type="primary" @click="dialogVisibleImport=true">导入白名单</el-button>
            </div>
            <!-- 表格内容 -->
            <el-table v-loading="loading" element-loading-text="数据加载中" stripe border :data="pageInfo.list">
                <el-table-column label="id" prop="id" width="100" align="center"></el-table-column>
                <el-table-column label="手机号" prop="phone" width="200" align="center"></el-table-column>
                <el-table-column label="备注" prop="remark" width="auto" align="center"></el-table-column>
                <el-table-column label="创建时间" prop="created_at" width="200" align="center"></el-table-column>
                <el-table-column label="更新时间" prop="updated_at" width="200" align="center">
                </el-table-column>
                <el-table-column label="操作" align="center" fixed="right" width="200">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-delete"  class="red" @click="deleteHandel(scope.$index, scope.row)">删除</el-button>
<!--                        <el-button type="text" icon="el-icon-edit" @click="edit(scope.$index, scope.row)">编辑</el-button>
                        <el-button v-if="scope.row.state === 2" type="text" class="red" @click="state(scope.row, 1)">下线 </el-button>
                        <el-button v-if="scope.row.state === 1" type="text" class="green" @click="state(scope.row, 2)"> 上线</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
            <!-- 上线、下线提示框 -->
            <el-dialog title="提示" :visible.sync="confirmVisible" width="300px" center>
                <div class="del-dialog-cnt">{{ confirmContent }}</div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="confirmVisible = false">取 消</el-button>
                    <el-button type="primary" @click="stateData">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 分页 -->
            <Pagination v-bind:pageInfo="pageInfo" v-on:refreshPageSize="refreshPageSize" v-on:refreshPageNum="refreshPageNum" />
        </div>
        <!-- 新增 编辑 -->
        <el-dialog :title="title" :visible.sync="addVisible" width="600px" class="dialog_box" v-if="addVisible">
            <el-form
                class="form-box"
                ref="form"
                v-bind:rules="rules"
                v-bind:model="form"
                v-loading.body="loading"
                label-position="left"
                label-suffix=":"
                label-width="150px"
                size="large"
                element-loading-text="上传中"
                style="margin-left: 30px"
            >
                <el-form-item label="手机号" prop="phone">
                    <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="form.remark" placeholder="请输入备注"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveData">提 交</el-button>
            </div>
        </el-dialog>

        <!-- 上线、下线提示框 -->
        <el-dialog title="提示" :visible.sync="confirmVisible" width="300px" center>
            <div class="del-dialog-cnt">{{ confirmContent }}</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmVisible = false">取 消</el-button>
                <el-button type="primary" @click="stateData">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog :visible.sync="dialogVisibleImport" width="600px" @close="upclose">
            <el-form ref="upform" :model="headers" label-width="80px">
                <el-form-item label="文件:">
                    <el-upload
                        class="upload-demo"
                        ref="upload"
                        :action="uploadUrl"
                        :file-list="fileList"
                        :auto-upload="false"
                        :before-upload="beforeUpload"
                        :on-success="handleUploadSuccess"
                        :on-error="handleUploadError"
                    >
                        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                        <div slot="tip" class="el-upload__tip">
                            只能上传.xlsx文件，且不超过2MB
                            <el-divider></el-divider>
                            <div>
                                表格格式如下
                                <el-table :data="exampleTableHeaderData" border style="width: 100%">
                                    <!-- 序号 -->
                                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                                    <!-- 卡号 -->
                                    <el-table-column prop="cardNumber" label="卡号" width="150"></el-table-column>
                                    <!-- 手机号 -->
                                    <el-table-column prop="phoneNumber" label="手机号" width="auto"></el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button type="primary" @click="submitUpload">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
import Breadcrumb from '@/components/Breadcrumb';
import Pagination from '@/components/Pagination';
import { request } from '@/common/request';
import { deal } from '@/common/main';
export default {
    name: 'StoreInfo',
    components: {
        Breadcrumb,
        Pagination
    },
    data() {
        return {
            menuList: ['客户', '手机白名单'],
            loading: false,
            confirmVisible: false,
            confirmContent: '',
            queryParams: {
                page: 1,
                pagesize: 10
            },
            pageInfo: {},
            channelList: [],
            addVisible: false,
            addVisibles: false,
            title: '添加手机号',
            rules: {
                phone: [
                    {
                        required: true,
                        message: '手机号不能为空',
                        trigger: 'blur'
                    }
                ],
                remark: [
                ],
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },

            mode: 'add',
            form: {
                channel_id: 0
            },
            headers:null,
            // 上传相关
            uploadUrl:"/i/admin/user/import",
            fileList: [],
            dialogVisibleImport:false,
            uplosuccess: false,
            exampleTableHeaderData: [
                { cardNumber: '1234567890', phoneNumber: '13800001111' },
                // 添加更多数据...
            ]

        };
    },
    created() {
        // this.hearder.token = localStorage.getItem('token');
        // this.hearder.platform = 'admin';
        this.loadData();
    },
    methods: {
        loadData() {
            this.loading = true;
            //用户等级列表
            request.get('/plug/phone/white/list', this.queryParams).then((ret) => {
                if (ret.code == 1) {
                    this.loading = false;
                    this.pageInfo = ret.data;
                    this.channelList = ret.data.channelList;
                    console.log(22222, this.pageInfo);
                    this.pageInfo.list = ret.data.list;
                    this.pageInfo.list.map(function (val) {});
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        //分页
        changeQuery() {
            this.queryParams.page = 1;
            this.loadData();
        },
        refreshPageSize(val) {
            this.queryParams.pagesize = val;
            this.loadData();
        },
        refreshPageNum(val) {
            this.queryParams.page = val;
            this.loadData();
        },
        add(id, index) {
            this.mode = 'add';
            this.title = '新增手机号';
            this.form = { num: 1, countType: 1, ty: 1 };
            this.addVisible = true;
            this.form = {
                state: 2,
                customer: 2,
                shipping: 2,
                shop: 2,
                useprice: 0
            };
            if (this.$refs.form) {
                this.$refs.form.clearValidate();
            }
            // this.addVisible = true
        },
        //状态
        state(row, state) {
            if (state == 2) {
                this.confirmContent = '确定是否上线?';
            } else {
                this.confirmContent = '确定是否下线?';
            }
            this.form = Object.assign({}, row);
            this.form.state = state;
            this.form.ctime = deal.timestamp(this.form.ctime);
            this.form.etime = deal.timestamp(this.form.etime);
            this.confirmVisible = true;
        },
        //编辑
        edit(index, row) {
            this.mode = 'edit';
            this.title = '编辑';
            const item = this.pageInfo.list[index];
            let time = [item.stime, item.etime];
            //处理时间
            this.form = Object.assign({}, item);
            this.$set(this.form, 'time', time);
            this.form.level = this.form.level + '';
            this.form.consumption = this.form.consumption + '';
            this.addVisible = true;
            if (this.$refs.form) {
                this.$refs.form.clearValidate();
            }
        },
        delete(id, index) {},
        changeCount(num) {
            this.form.num = num;
        },
        changeDatePicker: function () {
            let vue = this;
            if (vue.pickerDatad != null) {
                vue.form.stime = vue.pickerDatad[0];
                vue.form.etime = vue.pickerDatad[1];
            } else {
                vue.form.stime = null;
                vue.form.etime = null;
            }
        },
        //增加编辑
        saveData() {
            if (this.$refs.form) {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        //   this.form.num = this.form.countType == 1 ? 1 : this.form.num;
                        // this.form.brand_ids = this.form.brand_id;
                        var url = this.mode == 'add' ? '/plug/phone/white/add' : '/plug/phone/white/edit';
                        request.post(url, this.form).then((ret) => {
                            if (ret.code == 1) {
                                this.addVisible = false;
                                this.addVisibles = false;
                                this.loadData();
                                this.$message.success((this.mode == 'add' ? '新增' : '编辑') + '成功');
                                this.$refs.form.clearValidate();
                            } else {
                                this.$message.error(ret.msg);
                            }
                        });
                    } else {
                        this.$message.error('请补全信息');
                        return false;
                    }
                });
            }
        },
        // 确定下线
        stateData() {
            request.post('/account/grade/edit', this.form).then((ret) => {
                if (ret.code == 1) {
                    this.$message.success('操作成功');
                    this.loadData();
                    this.confirmVisible = false;
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        deleteHandel(index, row){
             let id = row.id
             let idsJson = JSON.stringify([id])

            request.post('/plug/phone/white/del', { ids: idsJson }).then((ret) => {
                if (ret.code === 1) {
                    this.$message.success('删除成功');
                }
            })
            setTimeout(() => {
                this.loadData()
            }, 1000)

        },
        // 导入弹窗关闭
        upclose() {
            this.headers = {
                session_id: null,
            };

            this.fileList = [];

        },
        submitUpload() {
            this.$refs.upload.submit();



            // 可选：显示一个提示信息告知用户导入已在后台进行
            this.$message.info('文件正在后台导入中...')


            setTimeout(() => {
                // 可选：关闭对话框
                this.dialogVisibleImport = false;
                //
                this.loadData() ;
            }, 3000);
        },
        beforeUpload(file) {
            const isValidType = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            const isValidSize = file.size / 1024 <= 2048; // 2mb

            if (!isValidType) {
                this.$message.error('只能上传 .xlsx 格式的文件!');
                return false;
            }

            if (!isValidSize) {
                this.$message.error('文件大小不能超过 500KB!');
                return false;
            }

            return true;
        },
        handleUploadSuccess(response, file, fileList) {
            if (response.code === 1) {
                this.$message.success('导入成功');
            } else {
                this.$message.error(response.msg || '导入失败');
            }
            this.dialogVisibleImport = false; // 无论成功失败都关闭对话框
            this.loadData(); // 重新加载数据
            this.fileList = []; // 清空文件列表
        },

        handleUploadError(err, file, fileList) {
            this.$message.error('上传失败，请重试');
            this.dialogVisibleImport = false; // 错误时也关闭对话框
            this.fileList = []; // 清空文件列表
        }
    }
};
</script>

<style scoped>
.red {
    color: #ff0000;
}

.green {
    color: green;
}
/* 对话框样式 */

.dialog_box >>> .el-dialog__body {
    padding: 20px 30px 20px 60px;
}

.dialog_box >>> .el-dialog__header {
    padding: 30px 30px 10px;
}

.dialog_box .el-form-item--small.el-form-item {
    margin-bottom: 20px;
}
</style>
